module.exports = __webpack_public_path__ + "img/app-1.b2b074aa.png";